module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "firm",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "18%",
      "model": _vm.firm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_psgname'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.name),
      callback: function($$v) {
        _vm.$set(_vm.firm, "name", $$v)
      },
      expression: "firm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor'),
      "prop": "mech"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_cbackad'),
      "prop": "callback"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.callback),
      callback: function($$v) {
        _vm.$set(_vm.firm, "callback", $$v)
      },
      expression: "firm.callback"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_bsrqsadwl'),
      "prop": "addr"
    }
  }, [_vm._l((_vm.dynamicTags_ip), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "type": "primary",
        "closable": true,
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleCloseIP(tag)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tag) + "\n\t\t\t\t")])
  }), _vm._v(" "), (_vm.inputVisible_ip) ? _c('el-input', {
    ref: "saveTagInput_ip",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": _vm.handleInputConfirmIP
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirmIP($event)
      }
    },
    model: {
      value: (_vm.inputValue_ip),
      callback: function($$v) {
        _vm.inputValue_ip = $$v
      },
      expression: "inputValue_ip"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInputIP
    }
  }, [_vm._v("      +" + _vm._s(_vm.$t('app_addaddr')) + "      ")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_appwtls'),
      "prop": ""
    }
  }, [_vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "type": "primary",
        "closable": true,
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleClose(tag)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tag) + "\n\t\t\t\t")])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("      +" + _vm._s(_vm.$t('app_addapppgkn')) + "      ")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_authstat'),
      "prop": ""
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.firm.authst),
      callback: function($$v) {
        _vm.$set(_vm.firm, "authst", $$v)
      },
      expression: "firm.authst"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_open1')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.firm.authst),
      callback: function($$v) {
        _vm.$set(_vm.firm, "authst", $$v)
      },
      expression: "firm.authst"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_close')))])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('firm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76a8e278"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/openpl/edit.vue
// module id = 1080
// module chunks = 0